module.exports = __webpack_public_path__ + "static/img/yxjtp.6e4c9b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yxjtp.png
// module id = 1YUn
// module chunks = 3